export const rmNames = [
  "Diamonds",
  "Precious Color Stones",
  "Semi Precious Stones",
  "Chain",
  "Finding",
];

export const rmId = {
  Diamonds: 1,
  "Precious Color Stones": 2,
  "Semi Precious Stones": 3,
  Pearl: 4,
  "Other Stones": 5,
  Metal: 6,
  Chain: 8,
  Finding: 7,
  Others: 9,
  LGD: 10,
};

export const CommodityGroup = {
  Diamonds: "ERM1",
  PreciousColorStones: "ERM2",
  SemiPreciousStones: "ERM3",
  Pearl: "ERM4",
  "Other Stones": "ERM5",
  Metal: "ERM6",
  Chain: "ERM8",
  Finding: "ERM7",
  Others: "ERM9",
  LGD: "ERM10",
};

export const tableHeader = [
  "Lot Code",
  " Commodity",
  "Shape",
  "Color",
  "Sieve Size",
  "MM Size",
  " Internal Quality",
  "MCP",
  "SP",
  "Action",
];

export const mapping = {
  ERM1: "Diamonds",
  ERM2: "Precious Color Stones",
  ERM3: "Semi Precious Stones",
  ERM8: "Chain",
  ERM7: "Finding",
};

export const commodityGroupMap = {
  Diamonds: CommodityGroup.Diamonds,
  "Precious Color Stones": CommodityGroup.PreciousColorStones,
  "Semi Precious Stones": CommodityGroup.SemiPreciousStones,
  Chain: CommodityGroup.Chain,
  Finding: CommodityGroup.Finding,
};


export const searchList =[
  "LotCode",
  "Commodity",
  "Shape",
  "Color",
  "SieveSize",
  "MMSize",
  "InternalQuality",
  
]


